module.exports = __webpack_public_path__ + "img/P55-zh.4549952f.png";